<div class="main-layout">
    <aside class="sidebar" [class.is-open]="isSidebarOpen()">
        <div class="sidebar-header">
            <div class="logo">
                <img src="logo_white.svg" alt="Besedan Logo">
            </div>
            <button class="button is-white close-btn" (click)="toggleSidebar()">
                <i class="ri-close-line"></i>
            </button>
        </div>

        @if(currentUser(); as user) {
        <nav class="sidebar-menu">
            <button class="menu-button" routerLink="/dashboard" routerLinkActive="active" (click)="closeSidebar()">
                <i class="ri-dashboard-line"></i>
                <span>
                    {{ 'pages.dashboard.title' | translate }}
                </span>
            </button>

            @for(section of visibleSections(); track section.id) {
            <section class="menu-section" [class.is-expanded]="isSectionExpanded(section.id)" [class.is-pinned]="section.pinned">
                @if(section.pinned) {
                <div class="menu-section-header">
                    <span class="menu-section-title">{{ section.titleKey | translate | uppercase }}</span>
                </div>
                } @else {
                <button type="button" class="menu-section-toggle" [class.is-expanded]="isSectionExpanded(section.id)"
                    (click)="toggleSection(section.id)" [attr.aria-expanded]="isSectionExpanded(section.id)">
                    <span class="menu-section-title">{{ section.titleKey | translate | uppercase }}</span>
                    <i class="ri-arrow-down-s-line section-chevron"></i>
                </button>
                }

                @if(isSectionExpanded(section.id)) {
                <div class="menu-section-items">
                    @for(item of section.items; track item.id) {
                    <button class="menu-button menu-button--nested" [class.menu-button--subnested]="item.subNested" [class.active]="isItemActive(item, section.items)" [routerLink]="item.route"
                        [queryParams]="item.queryParams || null" (click)="closeSidebar()">
                        <i [class]="item.icon"></i>
                        <span>{{ item.labelKey | translate }}</span>
                    </button>
                    }
                </div>
                }
            </section>
            }
        </nav>
        }
    </aside>

    <div class="content-wrapper">
        <header class="top-bar">
            <div class="page-title">
                <i class="ri-menu-line mobile-menu-btn" (click)="toggleSidebar()"></i>
            </div>

            @if(currentUser(); as user) {
            <div class="top-bar-actions">
                <app-notification-dropdown></app-notification-dropdown>
                
                <div class="dropdown is-right" [class.is-active]="isUserDropdownOpen()">
                    <div class="dropdown-trigger">
                        <div class="user-profile" (click)="toggleUserDropdown()" style="cursor: pointer;">
                            <div class="user-info">
                                <div class="name">{{ user.firstName }} {{ user.lastName }}</div>
                                <div class="organization">{{ user.organizationName }}</div>
                            </div>
                            <div class="avatar">
                                <span class="avatar-placeholder">{{ user.firstName.charAt(0) }}{{ user.lastName.charAt(0)
                                    }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="dropdown-menu" role="menu">
                        <div class="dropdown-content">
                            <a class="dropdown-item" (click)="openProfilePage()">
                                <span class="icon-text">
                                    <span class="icon">
                                        <i class="ri-user-line"></i>
                                    </span>
                                    <span>{{ 'layout.avatarMenu.viewProfile' | translate }}</span>
                                </span>
                            </a>
                            <hr class="dropdown-divider">
                            @if(isMockLogin$ | async) {
                            <a class="dropdown-item" (click)="exitMockLogin()">
                                <span class="icon-text">
                                    <span class="icon">
                                        <i class="ri-shield-user-line"></i>
                                    </span>
                                    <span>{{ 'layout.avatarMenu.exitMockLogin' | translate }}</span>
                                </span>
                            </a>
                            <hr class="dropdown-divider">
                            }
                            <a class="dropdown-item" (click)="logout()">
                                <span class="icon-text">
                                    <span class="icon">
                                        <i class="ri-logout-box-line"></i>
                                    </span>
                                    <span>
                                        {{ 'layout.avatarMenu.logout' | translate }}
                                    </span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            }
        </header>

        @for (notification of pinnedNotifications(); track notification.id) {
        <div class="notification pinned-notification"
            [class.is-danger]="notification.priority === 'CRITICAL'"
            [class.is-warning]="notification.priority === 'IMPORTANT'"
            [class.is-info]="notification.priority === 'INFO'">
            <button class="delete" (click)="dismissPinnedNotification(notification.id)"></button>
            <strong>{{ notification.title }}</strong>
            <span class="ml-2">{{ notification.body }}</span>
        </div>
        }

        <main class="main-content">
            <router-outlet></router-outlet>
        </main>
    </div>
</div>